import { FormPagePropertyItemMonthDay } from 'backend';
import { MONTH_DAY_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '..';

export const getMonthDayPropertyItemElementFormCustomize = (
  propertyItem: FormPagePropertyItemMonthDay,
): PropertyItemElement => {
  switch (propertyItem.inputFormat.inputType) {
    case MONTH_DAY_PROPERTY_INPUT_TYPE.free: {
      const month = document.querySelector<HTMLElement>(
        `input[data-nform-property-id="${propertyItem.propertyId}"][data-nform-value-into="month"]`,
      );
      const day = document.querySelector<HTMLElement>(
        `input[data-nform-property-id="${propertyItem.propertyId}"][data-nform-value-into="day"]`,
      );
      if (!month || !day) {
        return {};
      }
      return {
        month: month,
        day: day,
      };
    }
    case MONTH_DAY_PROPERTY_INPUT_TYPE.pulldown: {
      const month = document.querySelector<HTMLElement>(
        `select[data-nform-property-id="${propertyItem.propertyId}"][data-nform-value-into="month"]`,
      );
      const day = document.querySelector<HTMLElement>(
        `select[data-nform-property-id="${propertyItem.propertyId}"][data-nform-value-into="day"]`,
      );
      if (!month || !day) {
        return {};
      }
      return {
        month: month,
        day: day,
      };
    }
  }
};
